@if (media) {
  <video
    #player
    [loop]="loop"
    [muted]="muted"
    [autoplay]="autoplay"
    [poster]="media.poster"
    [preload]="media.poster ? 'none' : 'metadata'"
    [attr.playsInline]="playsInline ? '' : undefined"
  >
    @for (item of media.sources; track item.src) {
      <source [src]="item.src" [type]="item.type" />
    }
  </video>
}
@if (controls) {
  @if (!player || !player.nativeElement || player.nativeElement.paused === true) {
    <span class="play-icon mb-icon mb-icon-player-play"></span>
  }
}
